import { Button, Divider, Form, FormInstance, Input, message, Modal, Select, Space, Switch, Table } from "antd";
import Password from "antd/lib/input/Password";
import { useEffect, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";

const ComparisonMemberEdit = (props: any) => {
    const formRef = useRef<FormInstance>(null);
    const { ...rest } = props;
    const [salesData, setSalesData] = useState<any>([]);

    useEffect(() => {
        if (props.isOpen) {
            formRef.current?.resetFields();
            loadSales();
        }
    }, [props.isOpen])

    const loadSales = () => {
        Server.Post(URL.Sales.GetSalesOptions, {}, false).then((response: any) => {
            if (response.isSuccess) {
                setSalesData(response.data);
            }
        })
    }

    const handleCancel = () => {
        rest.setIsOpen(false);
    }

    const handleSave = () => {
        formRef.current?.validateFields().then((values => {
            var params = {
                ...values,
                salesID: values.sales?.value ?? null,
                salesName: values.sales?.label ?? null
            };
            Server.Post(URL.ComparisonMember.AddMember, params).then((response: any) => {
                if (response.isSuccess) {
                    message.success('保存成功');
                    rest.setIsOpen(false);
                    rest.loadData();
                } else {
                    message.warn(response.returnMsg);
                }
            })
        }));
    }
    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return <Modal title={"开通会员"} width={600} open={rest.isOpen}
        onCancel={handleCancel}
        maskClosable={false}
        bodyStyle={{ padding: '10px' }}
        footer={
            <Space>
                <Button onClick={handleSave} type='primary'>保存</Button>
                <Button onClick={handleCancel}>关闭</Button>
            </Space>
        }>
        <Form ref={formRef}
            labelCol={{ flex: '105px' }}
            labelWrap
            scrollToFirstError={true}>
            <Form.Item style={{ marginBottom: '5px' }} label={'会员账号'} name={'account'} initialValue={''} rules={[{ required: true, message: '请输入用户账号' }]}>
                <Input />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'会员密码'} name={'password'} initialValue={''} rules={[{ required: true, message: '请输入用户密码' }]}>
                <Password />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'会员名称'} name={'name'} initialValue={''} rules={[{ required: true, message: '请输入用户名称' }]}>
                <Input />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'手机号码'} name={'tel'} initialValue={''} rules={[{ required: true, pattern: new RegExp(/^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147)|19[0-1])\d{8}$/, 'g'), message: '请输入11位手机号码' }]}>
                <Input />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'公司名称'} name={'companyName'} initialValue={''}>
                <Input />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'业务员'}
                name={'sales'} initialValue={null}
                rules={[{ required: true, message: '请选择业务员' }]}>
                <Select labelInValue
                    allowClear
                    placeholder={'选择业务员'}
                    style={{ width: '100%' }}
                    options={salesData}
                    showSearch
                    optionFilterProp="children"
                    filterOption={filterOption} />
            </Form.Item>
        </Form>
    </Modal>
};
export default ComparisonMemberEdit;